import { createSlice } from "@reduxjs/toolkit";
import AsyncStorage from "@react-native-async-storage/async-storage";

import * as eva from "@eva-design/eva";
import { themeKey } from "utils/storageUtils";
export interface ThemeState {
  theme: "light" | "dark";
  customTheme: any;
}

const initialState: ThemeState = {
  theme: "light",
  customTheme: eva.light,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      // state.theme = state.theme === "light" ? "dark" : "light";
      // AsyncStorage.setItem(
      //   themeKey,
      //   state.theme === "light" ? "light" : "dark"
      // );
    },
    setTheme: (state, action) => {
      state.customTheme = action.payload;
    },
    resetTheme: () => {
      AsyncStorage.removeItem(themeKey);
      return initialState;
    },
  },
});

export const { toggleTheme, setTheme, resetTheme } = themeSlice.actions;

export default themeSlice.reducer;
